import React from 'react';
import { Sidebar } from 'semantic-ui-react';

const SidebarWrapper = ({ sidebarRight, sidebarContent, sidebarOn }) => {
  return (
    <Sidebar.Pushable style={{ overflow: 'hidden' }}>
      {sidebarRight}
      <Sidebar.Pusher dimmed={sidebarOn ? true : false} className="h100">
        {sidebarContent}
      </Sidebar.Pusher>
    </Sidebar.Pushable>
  );
};

export default SidebarWrapper;
